import { Box, Button, ClickAwayListener, Divider, Grid, Grow, MenuItem, MenuList, Paper, Popper, Tooltip, Typography } from "@material-ui/core"
import { SituacaoMock } from "data/mocks/situacao-mock"
import { FaturaModel } from "model/api/gestao/fatura/fatura-model"
import { FaturaFormModel } from "model/app/forms/fatura/fatura-form-model"
import { EnumSituacao } from "model/enums/enum-situacao"
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas"
import { forwardRef, useCallback, useMemo, useRef, useState } from "react"
import { useSessaoAtual } from "services/app"
import { DefaultFormRefs } from "views/components/form/utils"
import { BoletoIcon, CancelarIcon, ConfiguracaoIcon, DinheiroIcon, EditarIcon, QrCodeIcon, SalvarEditarIcon } from "views/components/icons"
import { useThemeQueries } from "views/theme"
import { useStyles } from './cliente-fatura-styles'
import { DialogFaturasFilhas } from "views/components/dialog/dialog-faturas-filhas/dialog-faturas-filhas"
import { isEmpty } from "lodash"
import { FormFaturaEdicao } from "views/components/form/master/fatura/fatura-edicao/form-fatura-edicao"
import { EnumTipoCobrancaRevenda } from "model/enums/enum-tipo-cobranca-revenda"
import { AccordionNotaFiscal } from "views/pages/private/notas-fiscais-revenda/components/accordions/accordion-nota-fiscal/accordion-nota-fiscal"
import { toDateString } from "utils/to-date"
import { formatarCPFCNPJ } from "utils/cpfcnpj-format"
import { EnumTipoComunicacao } from "model"
import { EnumTipoFatura } from "model/enums/enum-tipo-fatura"
import { MaoMoedaIcon } from "views/components/icons/mao-moeda-icon"
import { GerenteIcon } from "views/components/icons/gerente-icon"
import FaturaValores from "./cliente-fatura-valores"
import { WhatsappIcon } from "views/components/icons/whatsapp-icon"
import { FaturaPagamentoModel } from "model/api/gestao/fatura/fatura-pagamento-model"
import { DialogStatus } from "views/pages/private/notas-fiscais-revenda/components/notas-fiscais-editar/notas-fiscais-editar"
import { PagamentoModel } from "model/api/gestao/pagamento/pagamento-model"
import { ConfirmarIcon } from "views/components/icons/confirmar-icon"
import { DialogConfirmarPagamento } from "views/components/dialog/dialog-confirmar-pagamento/dialog-confirmar-pagamento"
import { AccordionHistoricoFatura } from "views/pages/private/notas-fiscais-revenda/components/accordions/accordion-historico-fatura/accordion-historico-fatura"
import { CalendarioIcon } from "views/components/icons/calendario-icon"
import { RetornarIcon } from "views/components/icons/retornar-icon"
import { CalculadoraIcon } from "views/components/icons/calculadora-icon"
import { useHistory } from "react-router-dom"

interface FaturaRefs extends DefaultFormRefs<FaturaFormModel> {
    validate(): Promise<boolean>;
    isFormEqual(form: FaturaFormModel): boolean;
}


interface Props {
    model: FaturaModel
    modelForm: FaturaFormModel
    funcoes: {
        bonificarFatura: () => boolean,
        cancelarFatura: () => boolean,
        reabrirFatura: () => boolean,
        sincronizarERP: () => Promise<void>;
        recalcularFatura: () => Promise<void>,
        preencherTela: () => Promise<void>,
    },
    carregando: boolean
    handleSubmit: (model: FaturaFormModel, baforeModel?: FaturaFormModel) => Promise<void>;
    pagarFatura: () => Promise<void>;
    pagarPix: (formaPagamento: PagamentoModel) => Promise<void>;
    setLiquidarDialog: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenCompetencia: React.Dispatch<React.SetStateAction<boolean>>;
    setPixDialog: React.Dispatch<React.SetStateAction<FaturaPagamentoModel & DialogStatus>>;
    cadForm: React.RefObject<FaturaRefs>;
}

export const ClienteFaturaInfo = forwardRef<
    DefaultFormRefs<FaturaFormModel>,
    Props
>(({ model, modelForm, funcoes, carregando, pagarFatura, pagarPix, handleSubmit, setLiquidarDialog, setOpenCompetencia, setPixDialog, cadForm }: Props, ref) => {

    const classes = useStyles()
    const { theme, isMobile } = useThemeQueries()
    const { tipoUsuario, usuario } = useSessaoAtual()
    const history = useHistory()

    const optionsRef = useRef<HTMLButtonElement>(null)
    const swOptionsRef = useRef<HTMLButtonElement>(null)

    const [openWhatsApp, setOpenWhatsApp] = useState<boolean>(false)
    const [openSWOptions, setOpenSWOptions] = useState<boolean>(false)

    const formaPagamentoPix = model.formasPagamentosDisponiveis.find(fp => fp.tipoComunicacao === EnumTipoComunicacao.Pix)


    //Funções opção WhatsApp

    const handleToggle = () => {
        setOpenWhatsApp((prevOpen) => !prevOpen);
    };

    const handleClose = (event: React.MouseEvent<EventTarget>) => {
        if (optionsRef.current && optionsRef.current.contains(event.target as HTMLElement)) {
            return;
        }

        setOpenWhatsApp(false);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenWhatsApp(false);
        }
    }

    //Funções de opções para Software House

    const handleToggleOptions = () => {
        setOpenSWOptions((prevOpen) => !prevOpen);
    };

    const handleCloseOptions = (event: React.MouseEvent<EventTarget>) => {
        if (swOptionsRef.current && swOptionsRef.current.contains(event.target as HTMLElement)) {
            return;
        }

        setOpenSWOptions(false);
    };

    function handleListKeyDownOptions(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenSWOptions(false);
        }
    }

    const loading = carregando;

    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogPagamento, setOpenDialogPagamento] = useState<boolean>(false)


    const retornarCorStatus = useCallback((): string => {
        switch (model.situacao) {
            case EnumSituacao.Aberta:
                return theme.palette.info.main
            case EnumSituacao.Paga:
                return theme.palette.success.main
            case EnumSituacao.Atraso:
                return theme.palette.warning.main
            case EnumSituacao.Bonificada:
                return '#D7096C'
            case EnumSituacao.Cancelada:
                return theme.palette.error.main
            case EnumSituacao.Fechada:
                return '#8346a6'
        }
        return theme.palette.info.main
    }, [model.situacao, theme.palette.error.main, theme.palette.info.main, theme.palette.success.main, theme.palette.warning.main]);

    const arrNumButtons = useMemo(() => {
        let arrayNumber: Array<number> = []

        if (
            tipoUsuario() !== EnumTipoPessoas.SoftwareHouse &&
            tipoUsuario() !== EnumTipoPessoas.FinanceiroSoftwareHouse &&
            tipoUsuario() !== EnumTipoPessoas.FinanceiroSoftwareHouseSemCusto
        ) {
            arrayNumber.push(-1)
            return arrayNumber
        }

        if (
            model.situacao !== EnumSituacao.Cancelada &&
            model.situacao !== EnumSituacao.Paga &&
            model.situacao !== EnumSituacao.Bonificada &&
            model.situacao !== EnumSituacao.BonificadoRevenda
        ) {
            arrayNumber.push(0)
        }

        if ((
            model.situacao === EnumSituacao.Aberta ||
            model.situacao === EnumSituacao.EmPagamento ||
            model.situacao === EnumSituacao.Atraso
        ) && tipoUsuario() === EnumTipoPessoas.SoftwareHouse) {
            arrayNumber.push(1)
        }

        if (model.situacao === EnumSituacao.Fechada || model.situacao === EnumSituacao.Cancelada || ((model.situacao === EnumSituacao.Paga || model.situacao === EnumSituacao.Bonificada || model.situacao === EnumSituacao.BonificadoRevenda) && tipoUsuario() === EnumTipoPessoas.SoftwareHouse &&
            (model.formaPagamento.tipoComunicacao === EnumTipoComunicacao.Dinheiro || model.formaPagamento.tipoComunicacao === EnumTipoComunicacao.Transferencia))) {
            arrayNumber.push(2)
        }

        if (model.situacao !== EnumSituacao.Cancelada && model.situacao !== EnumSituacao.Paga && model.situacao !== EnumSituacao.Bonificada && model.situacao !== EnumSituacao.BonificadoRevenda && ([EnumTipoPessoas.SoftwareHouse, EnumTipoPessoas.FinanceiroSoftwareHouse, EnumTipoPessoas.FinanceiroSoftwareHouseSemCusto].includes(tipoUsuario()))) {
            arrayNumber.push(3)
        }

        return arrayNumber
    }, [model.formaPagamento.tipoComunicacao, model.situacao, tipoUsuario])

    const redirectCobrancaToWhatsApp = useCallback(() => {
        const link = `Clique no link a seguir para ser redirecionado a página onde estão suas faturas: %0a ${encodeURIComponent(`https://licenciamento.saurus.net.br/cobranca?doc=${model.pagador.cpfCnpj}&codCliente=${model.contratoId}`)}`
        window.open(`https://wa.me/?text=${link}`)
    }, [model.contratoId, model.pagador.cpfCnpj])

    const redirectBoletoToWhatsApp = useCallback(() => {
        const link = `Clique no link a seguir para ser redirecionado ao boleto: %0a ${encodeURIComponent(model.boletoUrl)}`
        window.open(`https://wa.me/?text=${link}`)
    }, [model.boletoUrl])

    const redirectPixToWhatsApp = useCallback(() => {
        const link = model.pixCodigo
        window.open(`https://wa.me/?text=${link}`)
    }, [model.pixCodigo])

    // const formaPagamentoPix = useMemo(() => {
    //     if(model.formaPagamento.tipoComunicacao === EnumTipoComunicacao.Pix){
    //         return model.formaPagamento
    //     }
    //     const pix = model.formasPagamentosDisponiveis.find(fp => fp.tipoComunicacao === EnumTipoComunicacao.Pix)
    //     return !isEmpty(pix) ? pix : null
    // }, [model.formaPagamento, model.formasPagamentosDisponiveis])

    const hanilitarEdicao = useMemo(() => {
        return (model.situacao !== EnumSituacao.Paga && model.situacao !== EnumSituacao.Cancelada && model.situacao !== EnumSituacao.Bonificada && model.situacao !== EnumSituacao.BonificadoRevenda && model.situacao !== EnumSituacao.EmPagamento
            && (tipoUsuario() === EnumTipoPessoas.Revendedor ? (usuario?.TipoCobrancaRevenda === EnumTipoCobrancaRevenda.Revenda || usuario?.TipoCobrancaRevenda === EnumTipoCobrancaRevenda.RevendaPagas) : true))
    }, [model.situacao, tipoUsuario, usuario?.TipoCobrancaRevenda])

    const redirecionarParaPessoa = () => {
        if (model.contratoId) {
            history.push('/clientes/' + model.pagador.id)
            return
        }
        history.push('/revendedor/' + model.pagador.id)
    }

    return (
        <>
            <Grid item xs={12}>
                <Grid container className={classes.acoesCard} spacing={2}>
                    <Grid item xs={12} lg={8}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Box display='flex' justifyContent='space-between' gridGap={theme.spacing(1)} flexWrap='wrap'>
                                    <div style={{
                                        padding: '8px 20px',
                                        background: retornarCorStatus(),
                                        textAlign: 'center',
                                        color: '#fff',
                                        fontWeight: 600,
                                        borderRadius: 4,
                                    }}>
                                        {SituacaoMock.find(item => item.Key === model.situacao)?.Value}
                                    </div>
                                    <Box display='flex' gridGap={theme.spacing(1)}>
                                        {!arrNumButtons.includes(-1) && <Button onClick={() => { setOpenCompetencia(true) }} variant='outlined' color='primary'>
                                            <EditarIcon tipo='BUTTON' />
                                            Editar Competência
                                        </Button>}

                                        <Button ref={optionsRef} variant='outlined' color='primary' size='medium' onClick={handleToggle}>
                                            <WhatsappIcon tipo='BUTTON' style={{ margin: 0 }} />
                                        </Button>

                                        <Popper open={openWhatsApp} anchorEl={optionsRef.current} role={undefined} transition disablePortal style={{ zIndex: 9999 }}>
                                            {({ TransitionProps, placement }) => (
                                                <Grow
                                                    {...TransitionProps}
                                                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                                >
                                                    <Paper>
                                                        <ClickAwayListener onClickAway={handleClose}>
                                                            <MenuList autoFocusItem={openWhatsApp} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                                <MenuItem onClick={redirectCobrancaToWhatsApp}>Enviar Link de Cobrança</MenuItem>
                                                                {(!isEmpty(model.pixCodigo)) && <MenuItem onClick={redirectPixToWhatsApp}>Enviar Pix Copia e Cola</MenuItem>}
                                                                {(!isEmpty(model.boletoUrl)) && <MenuItem onClick={redirectBoletoToWhatsApp}>Enviar Boleto</MenuItem>}
                                                            </MenuList>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                </Grow>
                                            )}
                                        </Popper>

                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Typography variant='caption' color='textSecondary'>Número da Fatura</Typography>
                                <Typography className={classes.boldText}>{model.nossoNumero}</Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Typography variant='caption' color='textSecondary'>Ano/Mês</Typography>
                                <Typography className={classes.boldText}>{model.competenciaAnoMes}</Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Typography variant='caption' color='textSecondary'>Data de Emissão</Typography>
                                <Typography className={classes.boldText}>{toDateString(model.dataEmissao, 'DD/MM/yyyy HH:mm')}</Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Typography variant='caption' color='textSecondary'>Data do Registro</Typography>
                                <Typography className={classes.boldText}>{toDateString(model.dataRegistro, 'DD/MM/yyyy HH:mm')}</Typography>
                            </Grid>
                            <Grid item xs={10}>
                                <Typography variant='caption' color='textSecondary'>Descrição</Typography>
                                <Typography className={classes.boldText}>{model.descricao}</Typography>
                            </Grid>
                            {!isEmpty(model.dataSincronizacaoERP) && (
                                <Grid item xs={2} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <Tooltip title={`Data de Sincronização: ${toDateString(model.dataSincronizacaoERP + 'Z', 'DD/MM/yyyy HH:mm')}`}>
                                        <Box>
                                            <CalendarioIcon tipo='BUTTON' />
                                        </Box>
                                    </Tooltip>
                                </Grid>
                            )}
                            {(model.situacao === EnumSituacao.Paga || model.situacao === EnumSituacao.Cancelada) && (
                                <>
                                    {/*Campos Especiais*/}
                                    <Grid item xs={12}>
                                        <Divider style={{ background: theme.palette.divider }} />
                                    </Grid>
                                    {(model.situacao === EnumSituacao.Paga) && (
                                        <>
                                            <Grid item xs={12} md={5}>
                                                <Typography variant='caption' color='textSecondary'>Data do Pagamento</Typography>
                                                <Typography>{toDateString(model.dataPagamento, 'DD/MM/yyyy HH:mm')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={5}>
                                                <Typography variant='caption' color='textSecondary'>Valor Pago</Typography>
                                                <Typography>{model.valorPago.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Typography>
                                            </Grid>
                                        </>
                                    )}
                                    {model.situacao === EnumSituacao.Cancelada && (
                                        <>
                                            <Grid item xs={12} md={5}>
                                                <Typography variant='caption' color='textSecondary'>Data do Cancelamento</Typography>
                                                <Typography className={classes.boldText}>{toDateString(model.dataCancelamento + 'Z', 'DD/MM/yyyy HH:mm')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={5}>
                                                <Typography variant='caption' color='textSecondary'>Motivo do Cancelamento</Typography>
                                                <Typography className={classes.boldText}></Typography>
                                            </Grid>
                                        </>
                                    )}
                                    {/*------------*/}
                                </>
                            )}
                            <Grid item xs={12}>
                                <Divider style={{ background: theme.palette.divider }} />
                            </Grid>
                            <Grid item md={8} xs={12} style={{ display: 'flex', alignItems: 'center', gap: theme.spacing(2) }}>
                                {!isMobile && <MaoMoedaIcon />}
                                <Box>
                                    <Typography variant='caption' color='textSecondary'>Pagador</Typography>
                                    <Box onClick={redirecionarParaPessoa} className={classes.linkPagador}>
                                        <Typography>
                                            {model.pagador.nomeComercial}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <Typography variant='caption' color='textSecondary'>Pagador Documento</Typography>
                                <Typography>{formatarCPFCNPJ(model.pagador.cpfCnpj)}</Typography>
                            </Grid>
                            <Grid item md={8} xs={12} style={{ display: 'flex', gap: theme.spacing(2) }}>
                                {!isMobile && <GerenteIcon tipo='GERAL' style={{ width: 30, fill: theme.palette.primary.main }} />}
                                <Box>
                                    <Typography variant='caption' color='textSecondary'>Beneficiário</Typography>
                                    <Typography>{model.beneficiario.nomeComercial}</Typography>
                                </Box>
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <Typography variant='caption' color='textSecondary'>Pagador Documento</Typography>
                                <Typography>{formatarCPFCNPJ(model.beneficiario.cpfCnpj)}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <Grid container className={classes.contentContainer} spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant='h6'>Valores</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider style={{ background: theme.palette.primary.main, marginBottom: theme.spacing(2) }} />
                            </Grid>
                            <Grid item xs={12}>
                                {!hanilitarEdicao ? (
                                    <FaturaValores formaPagamentoNome={model.formaPagamento.nome} model={modelForm} tipoFatura={model.tipoFatura} onCustoAtualizado={funcoes.preencherTela} />
                                ) : (
                                    <>
                                        <FormFaturaEdicao
                                            ref={cadForm}
                                            loading={loading}
                                            showLoading={loading}
                                            model={modelForm}
                                            onSubmit={handleSubmit}
                                            valorOriginal={model.valor - (model.encargo + model.multaJuros)}
                                            formaPagamento={model.formaPagamento}
                                            tipoFatura={model.tipoFatura}
                                        />
                                        {hanilitarEdicao && (
                                            <Button variant='contained' color='primary' fullWidth onClick={() => {
                                                cadForm.current?.submitForm()
                                            }}>
                                                <SalvarEditarIcon tipo='BUTTON_PRIMARY' />
                                                Salvar Fatura
                                            </Button>
                                        )}
                                    </>
                                )}
                            </Grid>
                            <Grid item xs={12}>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider style={{ background: theme.palette.divider }} />
                    </Grid>
                    <Grid item xs={12} className={classes.acoesCardButtonsContainer}>
                        <div className={classes.acoesCardButtons}>
                            {!arrNumButtons.includes(-1) && <Button variant='outlined' color='primary' onClick={handleToggleOptions} ref={swOptionsRef}>
                                <ConfiguracaoIcon tipo='BUTTON' />
                                Opções
                            </Button>}
                            <Popper open={openSWOptions} anchorEl={swOptionsRef.current} placement="top" role={undefined} transition disablePortal style={{ zIndex: 999 }}>
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                    >
                                        <Paper>
                                            <ClickAwayListener onClickAway={handleCloseOptions}>
                                                <MenuList autoFocusItem={openSWOptions} id="menu-list-grow" onKeyDown={handleListKeyDownOptions}>
                                                    <MenuItem onClick={funcoes.reabrirFatura}>
                                                        <Box display='flex' alignItems='center'>
                                                            <ConfirmarIcon tipo='BUTTON' />
                                                            <Typography color='primary'>Reabrir</Typography>
                                                        </Box>
                                                    </MenuItem>
                                                    <MenuItem onClick={funcoes.bonificarFatura}>
                                                        <Box display='flex' alignItems='center'>
                                                            <ConfirmarIcon tipo='BUTTON' />
                                                            <Typography color='primary'>Bonificar</Typography>
                                                        </Box>
                                                    </MenuItem>
                                                    <MenuItem onClick={() => setLiquidarDialog(true)}>
                                                        <Box display='flex' alignItems='center'>
                                                            <DinheiroIcon tipo='BUTTON' />
                                                            <Typography color='primary'>Liquidar Manual</Typography>
                                                        </Box>
                                                    </MenuItem>
                                                    <MenuItem onClick={funcoes.sincronizarERP}>
                                                        <Box display='flex' alignItems='center'>
                                                            <RetornarIcon tipo='BUTTON' />
                                                            <Typography color='primary'>Sincronizar ERP</Typography>
                                                        </Box>
                                                    </MenuItem>
                                                    <MenuItem onClick={funcoes.recalcularFatura}>
                                                        <Box display='flex' alignItems='center'>
                                                            <CalculadoraIcon tipo='BUTTON' />
                                                            <Typography color='primary'>Recalcular Fatura</Typography>
                                                        </Box>
                                                    </MenuItem>
                                                    <MenuItem onClick={funcoes.cancelarFatura}>
                                                        <CancelarIcon tipo='BUTTON' />
                                                        <Typography color='primary'>Cancelar</Typography>
                                                    </MenuItem>
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>

                        </div>
                        <div className={classes.acoesCardButtons}>
                            {!isEmpty(model.boletoUrl) && <Button
                                disabled={loading}
                                onClick={() => window.open(model.boletoUrl, '_blank')}
                                color='primary'
                                variant='contained'
                                fullWidth
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                <BoletoIcon tipo='BUTTON_PRIMARY' />
                                Visualizar Boleto
                            </Button>}
                            {(!isEmpty(model.pixCodigo)) && <Button
                                disabled={loading}
                                onClick={() => setPixDialog({
                                    aberto: true,
                                    codigoDeBarras: '',
                                    linhaDigitavel: '',
                                    nossoNumero: model.nossoNumero,
                                    pixChave: '',
                                    pixCopiaCola: model.pixCodigo,
                                    url: model.boletoUrl,
                                    dhExpiracaoPix: model.dhExpiracaoPix
                                })}
                                color='primary'
                                variant='contained'
                                fullWidth
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                <QrCodeIcon tipo='BUTTON_PRIMARY' />
                                Visualizar PIX
                            </Button>}
                            {(isEmpty(model.pixCodigo) &&
                                !isEmpty(model.boletoUrl) &&
                                model.situacao !== EnumSituacao.Paga &&
                                model.situacao !== EnumSituacao.Bonificada &&
                                model.situacao !== EnumSituacao.Cancelada &&
                                model.situacao !== EnumSituacao.BonificadoRevenda &&
                                formaPagamentoPix) && (
                                    <Button variant='outlined' color='primary' onClick={() => setOpenDialogPagamento(true)} fullWidth style={{ whiteSpace: 'nowrap' }}>
                                        <QrCodeIcon tipo='BUTTON' />
                                        Pagar com PIX
                                    </Button>
                                )}
                            {(model.situacao !== EnumSituacao.Paga && model.situacao !== EnumSituacao.Bonificada &&
                                model.situacao !== EnumSituacao.Cancelada && model.situacao !== EnumSituacao.EmPagamento) &&
                                <Button
                                    disabled={loading}
                                    onClick={pagarFatura}
                                    variant='contained'
                                    color='primary'
                                    size='large'
                                    fullWidth
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                    <DinheiroIcon tipo='BUTTON_PRIMARY' />
                                    Pagar Fatura
                                </Button>}
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            {model.tipoFatura !== EnumTipoFatura.Licença && <Grid item xs={12}>
                <AccordionNotaFiscal model={model} />
            </Grid>}
            {model.historico.length > 0 && <Grid item xs={12}>
                <AccordionHistoricoFatura model={model} />
            </Grid>}
            <DialogFaturasFilhas
                faturas={model.faturasFilhas}
                closeDialog={() => setOpenDialog(false)}
                openned={openDialog}
                faturaId={model.id}
            />
            <DialogConfirmarPagamento
                openned={openDialogPagamento}
                closeDialog={() => setOpenDialogPagamento(false)}
                formasPagamento={model.formasPagamentosDisponiveis}
                pagarPix={pagarPix}
            />
        </>
    )
})